import axios from 'axios';

axios.defaults.headers.common['X-CSRF-TOKEN'] = document.cookie.split("=")[1];

//const baseUrl = 'http://localhost:4810/Api';

export default {




    //********************************************************************| Authintecations |***********************************************************

    login(bodyObjeect) {
        return axios.post(`/Security/login`, bodyObjeect);
    },

    IsLoggedin() {
        return axios.get(`/Security/IsLoggedin`);
    },

    Logout() {
        return axios.post(`/Security/Logout`);
    },




    // ********************************| Start Farmes |******************************


    GetFarmes(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Farmes/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllFarmes() {
        return axios.get(`api/admin/Farmes/GetAll`);
    },

    GetMyFarmes() {
        return axios.get(`api/admin/Farmes/MyFarmes/Get`);
    },

    AddFarmes(bodyObject) {
        return axios.post(`api/admin/Farmes/Add`, bodyObject);
    },

    EditFarmes(bodyObject) {
        return axios.post(`api/admin/Farmes/Edit`, bodyObject);
    },

    DeleteFarmes(Id) {
        return axios.post(`api/admin/Farmes/${Id}/Delete`);
    },





    //FarmesSoilAnalysis
    GetFarmesSoilAnalysis(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Farmes/FarmesSoilAnalysis/Get?pageno=${pageNo}&pagesize=${pageSize}
        &Search=${Search}`);
    },

    AddFarmesSoilAnalysis(bodyObject) {
        return axios.post(`api/admin/Farmes/FarmesSoilAnalysis/Add`, bodyObject);
    },

    EditFarmesSoilAnalysis(bodyObject) {
        return axios.post(`api/admin/Farmes/FarmesSoilAnalysis/Edit`, bodyObject);
    },

    DeleteFarmesSoilAnalysis(Id) {
        return axios.post(`api/admin/Farmes/${Id}/FarmesSoilAnalysis/Delete`);
    },



    //FarmesSoilAnalysisInfoInfo
    GetFarmesSoilAnalysisInfo(Id) {
        return axios.get(`api/admin/Farmes/FarmesSoilAnalysisInfo/Get?Id=${Id}`);
    },

    AddFarmesSoilAnalysisInfo(bodyObject) {
        return axios.post(`api/admin/Farmes/FarmesSoilAnalysisInfo/Add`, bodyObject);
    },

    EditFarmesSoilAnalysisInfo(bodyObject) {
        return axios.post(`api/admin/Farmes/FarmesSoilAnalysisInfo/Edit`, bodyObject);
    },

    DeleteFarmesSoilAnalysisInfo(Id) {
        return axios.post(`api/admin/Farmes/${Id}/FarmesSoilAnalysisInfo/Delete`);
    },






    //FarmesWaterAnalysis
    GetFarmesWaterAnalysis(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Farmes/FarmesWaterAnalysis/Get?pageno=${pageNo}&pagesize=${pageSize}
        &Search=${Search}`);
    },

    AddFarmesWaterAnalysis(bodyObject) {
        return axios.post(`api/admin/Farmes/FarmesWaterAnalysis/Add`, bodyObject);
    },

    EditFarmesWaterAnalysis(bodyObject) {
        return axios.post(`api/admin/Farmes/FarmesWaterAnalysis/Edit`, bodyObject);
    },

    DeleteFarmesWaterAnalysis(Id) {
        return axios.post(`api/admin/Farmes/${Id}/FarmesWaterAnalysis/Delete`);
    },



    //FarmesWaterAnalysisInfo
    GetFarmesWaterAnalysisInfo(Id) {
        return axios.get(`api/admin/Farmes/FarmesWaterAnalysisInfo/Get?Id=${Id}`);
    },

    AddFarmesWaterAnalysisInfo(bodyObject) {
        return axios.post(`api/admin/Farmes/FarmesWaterAnalysisInfo/Add`, bodyObject);
    },

    EditFarmesWaterAnalysisInfo(bodyObject) {
        return axios.post(`api/admin/Farmes/FarmesWaterAnalysisInfo/Edit`, bodyObject);
    },

    DeleteFarmesWaterAnalysisInfo(Id) {
        return axios.post(`api/admin/Farmes/${Id}/FarmesWaterAnalysisInfo/Delete`);
    },



    //FarmesPower
    GetFarmesPower(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Farmes/FarmesPower/Get?pageno=${pageNo}&pagesize=${pageSize}
        &Search=${Search}`);
    },

    AddFarmesPower(bodyObject) {
        return axios.post(`api/admin/Farmes/FarmesPower/Add`, bodyObject);
    },

    EditFarmesPower(bodyObject) {
        return axios.post(`api/admin/Farmes/FarmesPower/Edit`, bodyObject);
    },

    DeleteFarmesPower(Id) {
        return axios.post(`api/admin/Farmes/${Id}/FarmesPower/Delete`);
    },



    //Groups
    GetGroups(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Farmes/Groups/Get?pageno=${pageNo}&pagesize=${pageSize}
        &Search=${Search}`);
    },

    GetAllGroups(Id) {
        return axios.get(`api/admin/Farmes/Groups/GetAll?Id=${Id}`);
    },

    AddGroups(bodyObject) {
        return axios.post(`api/admin/Farmes/Groups/Add`, bodyObject);
    },

    EditGroups(bodyObject) {
        return axios.post(`api/admin/Farmes/Groups/Edit`, bodyObject);
    },

    DeleteGroups(Id) {
        return axios.post(`api/admin/Farmes/${Id}/Groups/Delete`);
    },



    // ********************************| End Farmes |********************************












    // ********************************| Start Palms |******************************

    //Palms
    GetPalms(pageNo, pageSize, Search, ByFarmesId, ByGroupsId, ByIsEmpty) {
        return axios.get(`api/admin/Palms/Get?pageno=${pageNo}&pagesize=${pageSize}
        &Search=${Search}&FarmesId=${ByFarmesId}&GroupsId=${ByGroupsId}&IsEmpty=${ByIsEmpty}`);
    },

    GetAvailablePalms(FarmesId, GroupsId) {
        return axios.get(`api/admin/Palms/GetAvailable?FarmesId=${FarmesId}&GroupsId=${GroupsId}`);
    },

    GetNotAvailablePalms(FarmesId, GroupsId) {
        return axios.get(`api/admin/Palms/GetNotAvailable?FarmesId=${FarmesId}&GroupsId=${GroupsId}`);
    },

    GetAllAvailablePalms(FarmesId, GroupsId) {
        return axios.get(`api/admin/Palms/GetAllAvailable?FarmesId=${FarmesId}&GroupsId=${GroupsId}`);
    },

    AddPalms(bodyObject) {
        return axios.post(`api/admin/Palms/Add`, bodyObject);
    },

    EditPalms(bodyObject) {
        return axios.post(`api/admin/Palms/Edit`, bodyObject);
    },

    DeletePalms(Id) {
        return axios.post(`api/admin/${Id}/Palms/Delete`);
    },






    //PalmsFertilization
    GetPalmsFertilization(pageNo, pageSize, Search, ByFarmesId, ByGroupsId) {
        return axios.get(`api/admin/Palms/PalmsFertilization/Get?pageno=${pageNo}&pagesize=${pageSize}
        &Search=${Search}&FarmesId=${ByFarmesId}&GroupsId=${ByGroupsId}`);
    },

    AddPalmsFertilization(bodyObject) {
        return axios.post(`api/admin/Palms/PalmsFertilization/Add`, bodyObject);
    },

    EditPalmsFertilization(bodyObject) {
        return axios.post(`api/admin/Palms/PalmsFertilization/Edit`, bodyObject);
    },

    DeletePalmsFertilization(Id) {
        return axios.post(`api/admin/Palms/${Id}/PalmsFertilization/Delete`);
    },



    //PalmsSeedlings
    GetPalmsSeedlings(pageNo, pageSize, Search, ByFarmesId, ByGroupsId) {
        return axios.get(`api/admin/Palms/PalmsSeedlings/Get?pageno=${pageNo}&pagesize=${pageSize}
        &Search=${Search}&FarmesId=${ByFarmesId}&GroupsId=${ByGroupsId}`);
    },

    AddPalmsSeedlings(bodyObject) {
        return axios.post(`api/admin/Palms/PalmsSeedlings/Add`, bodyObject);
    },

    EditPalmsSeedlings(bodyObject) {
        return axios.post(`api/admin/Palms/PalmsSeedlings/Edit`, bodyObject);
    },

    DeletePalmsSeedlings(Id) {
        return axios.post(`api/admin/Palms/${Id}/PalmsSeedlings/Delete`);
    },


    //PalmsProduction
    GetPalmsProduction(pageNo, pageSize, Search, ByFarmesId, ByGroupsId) {
        return axios.get(`api/admin/Palms/PalmsProduction/Get?pageno=${pageNo}&pagesize=${pageSize}
        &Search=${Search}&FarmesId=${ByFarmesId}&GroupsId=${ByGroupsId}`);
    },

    AddPalmsProduction(bodyObject) {
        return axios.post(`api/admin/Palms/PalmsProduction/Add`, bodyObject);
    },

    EditPalmsProduction(bodyObject) {
        return axios.post(`api/admin/Palms/PalmsProduction/Edit`, bodyObject);
    },

    DeletePalmsProduction(Id) {
        return axios.post(`api/admin/Palms/${Id}/PalmsProduction/Delete`);
    },



    //PalmsPreventiveOperations
    GetPalmsPreventiveOperations(pageNo, pageSize, Search, ByFarmesId, ByGroupsId) {
        return axios.get(`api/admin/Palms/PalmsPreventiveOperations/Get?pageno=${pageNo}&pagesize=${pageSize}
        &Search=${Search}&FarmesId=${ByFarmesId}&GroupsId=${ByGroupsId}`);
    },

    AddPalmsPreventiveOperations(bodyObject) {
        return axios.post(`api/admin/Palms/PalmsPreventiveOperations/Add`, bodyObject);
    },

    EditPalmsPreventiveOperations(bodyObject) {
        return axios.post(`api/admin/Palms/PalmsPreventiveOperations/Edit`, bodyObject);
    },

    DeletePalmsPreventiveOperations(Id) {
        return axios.post(`api/admin/Palms/${Id}/PalmsPreventiveOperations/Delete`);
    },



    //PalmsPests
    GetPalmsPests(pageNo, pageSize, Search, ByFarmesId, ByGroupsId) {
        return axios.get(`api/admin/Palms/PalmsPests/Get?pageno=${pageNo}&pagesize=${pageSize}
        &Search=${Search}&FarmesId=${ByFarmesId}&GroupsId=${ByGroupsId}`);
    },

    AddPalmsPests(bodyObject) {
        return axios.post(`api/admin/Palms/PalmsPests/Add`, bodyObject);
    },

    EditPalmsPests(bodyObject) {
        return axios.post(`api/admin/Palms/PalmsPests/Edit`, bodyObject);
    },

    DeletePalmsPests(Id) {
        return axios.post(`api/admin/Palms/${Id}/PalmsPests/Delete`);
    },


    //PalmsCare
    GetPalmsCare(pageNo, pageSize, Search, ByFarmesId, ByGroupsId) {
        return axios.get(`api/admin/Palms/PalmsCare/Get?pageno=${pageNo}&pagesize=${pageSize}
        &Search=${Search}&FarmesId=${ByFarmesId}&GroupsId=${ByGroupsId}`);
    },

    AddPalmsCare(bodyObject) {
        return axios.post(`api/admin/Palms/PalmsCare/Add`, bodyObject);
    },

    EditPalmsCare(bodyObject) {
        return axios.post(`api/admin/Palms/PalmsCare/Edit`, bodyObject);
    },

    DeletePalmsCare(Id) {
        return axios.post(`api/admin/Palms/${Id}/PalmsCare/Delete`);
    },

    // ********************************| End Palms |********************************







    // ********************************| Start Dictionaries |********************************

    // Cities
    GetCities(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/Cities/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllCities() {
        return axios.get(`api/admin/Dictionaries/Cities/GetAll`);
    },

    AddCities(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Cities/Add`, bodyObject);
    },

    EditCities(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Cities/Edit`, bodyObject);
    },

    DeleteCities(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Cities/Delete`);
    },

    ChangeStatusCities(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Cities/ChangeStatus`);
    },


    // Municipalities
    GetMunicipalities(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/Municipalities/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllMunicipalities(Id) {
        return axios.get(`api/admin/Dictionaries/Municipalities/GetAll?CitiesId=${Id}`);
    },

    AddMunicipalities(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Municipalities/Add`, bodyObject);
    },

    EditMunicipalities(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Municipalities/Edit`, bodyObject);
    },

    DeleteMunicipalities(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Municipalities/Delete`);
    },

    ChangeStatusMunicipalities(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Municipalities/ChangeStatus`);
    },


    // FertilizationCompanies
    GetFertilizationCompanies(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/FertilizationCompanies/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllFertilizationCompanies() {
        return axios.get(`api/admin/Dictionaries/FertilizationCompanies/GetAll`);
    },

    AddFertilizationCompanies(bodyObject) {
        return axios.post(`api/admin/Dictionaries/FertilizationCompanies/Add`, bodyObject);
    },

    EditFertilizationCompanies(bodyObject) {
        return axios.post(`api/admin/Dictionaries/FertilizationCompanies/Edit`, bodyObject);
    },

    DeleteFertilizationCompanies(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/FertilizationCompanies/Delete`);
    },

    ChangeStatusFertilizationCompanies(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/FertilizationCompanies/ChangeStatus`);
    },


    // Fertilization
    GetFertilization(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/Fertilization/Get?pageno=${pageNo}&pagesize=${pageSize}
        &Search=${Search}`);
    },

    GetAllFertilization(Id) {
        return axios.get(`api/admin/Dictionaries/Fertilization/GetAll?CompaniesId=${Id}`);
    },

    AddFertilization(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Fertilization/Add`, bodyObject);
    },

    EditFertilization(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Fertilization/Edit`, bodyObject);
    },

    DeleteFertilization(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Fertilization/Delete`);
    },

    ChangeStatusFertilization(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Fertilization/ChangeStatus`);
    },


    // PalmsType
    GetPalmsType(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/PalmsType/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllPalmsType() {
        return axios.get(`api/admin/Dictionaries/PalmsType/GetAll`);
    },

    AddPalmsType(bodyObject) {
        return axios.post(`api/admin/Dictionaries/PalmsType/Add`, bodyObject);
    },

    EditPalmsType(bodyObject) {
        return axios.post(`api/admin/Dictionaries/PalmsType/Edit`, bodyObject);
    },

    DeletePalmsType(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/PalmsType/Delete`);
    },

    ChangeStatusPalmsType(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/PalmsType/ChangeStatus`);
    },


    // PalmsCareType
    GetPalmsCareType(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/PalmsCareType/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllPalmsCareType() {
        return axios.get(`api/admin/Dictionaries/PalmsCareType/GetAll`);
    },

    AddPalmsCareType(bodyObject) {
        return axios.post(`api/admin/Dictionaries/PalmsCareType/Add`, bodyObject);
    },

    EditPalmsCareType(bodyObject) {
        return axios.post(`api/admin/Dictionaries/PalmsCareType/Edit`, bodyObject);
    },

    DeletePalmsCareType(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/PalmsCareType/Delete`);
    },

    ChangeStatusPalmsCareType(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/PalmsCareType/ChangeStatus`);
    },


    // PestsCompanies
    GetPestsCompanies(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/PestsCompanies/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllPestsCompanies() {
        return axios.get(`api/admin/Dictionaries/PestsCompanies/GetAll`);
    },

    AddPestsCompanies(bodyObject) {
        return axios.post(`api/admin/Dictionaries/PestsCompanies/Add`, bodyObject);
    },

    EditPestsCompanies(bodyObject) {
        return axios.post(`api/admin/Dictionaries/PestsCompanies/Edit`, bodyObject);
    },

    DeletePestsCompanies(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/PestsCompanies/Delete`);
    },

    ChangeStatusPestsCompanies(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/PestsCompanies/ChangeStatus`);
    },




    // Pests
    GetPests(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/Pests/Get?pageno=${pageNo}&pagesize=${pageSize}
        &Search=${Search}`);
    },
    GetPestsAll() {
        return axios.get(`api/admin/Dictionaries/Pests/GetPestsAll`);
    },
    GetAllPests(Id) {
        return axios.get(`api/admin/Dictionaries/Pests/GetAll?CompaniesId=${Id}`);
    },

    AddPests(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Pests/Add`, bodyObject);
    },

    EditPests(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Pests/Edit`, bodyObject);
    },

    DeletePests(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Pests/Delete`);
    },

    ChangeStatusPests(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Pests/ChangeStatus`);
    },


    // Classifications
    GetClassifications(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/Classifications/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllClassifications() {
        return axios.get(`api/admin/Dictionaries/Classifications/GetAll`);
    },

    AddClassifications(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Classifications/Add`, bodyObject);
    },

    EditClassifications(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Classifications/Edit`, bodyObject);
    },

    DeleteClassifications(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Classifications/Delete`);
    },

    ChangeStatusClassifications(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Classifications/ChangeStatus`);
    },



    // PesticidesCompanies
    GetPesticidesCompanies(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/PesticidesCompanies/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllPesticidesCompanies() {
        return axios.get(`api/admin/Dictionaries/PesticidesCompanies/GetAll`);
    },

    AddPesticidesCompanies(bodyObject) {
        return axios.post(`api/admin/Dictionaries/PesticidesCompanies/Add`, bodyObject);
    },

    EditPesticidesCompanies(bodyObject) {
        return axios.post(`api/admin/Dictionaries/PesticidesCompanies/Edit`, bodyObject);
    },

    DeletePesticidesCompanies(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/PesticidesCompanies/Delete`);
    },

    ChangeStatusPesticidesCompanies(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/PesticidesCompanies/ChangeStatus`);
    },



    // Pesticides
    GetPesticides(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/Pesticides/Get?pageno=${pageNo}&pagesize=${pageSize}
        &Search=${Search}`);
    },

    GetAllPesticides(Id) {
        return axios.get(`api/admin/Dictionaries/Pesticides/GetAll?CompaniesId=${Id}`);
    },

    AddPesticides(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Pesticides/Add`, bodyObject);
    },

    EditPesticides(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Pesticides/Edit`, bodyObject);
    },

    DeletePesticides(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Pesticides/Delete`);
    },

    ChangeStatusPesticides(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Pesticides/ChangeStatus`);
    },



    // SubscriptionsTypes
    GetSubscriptionsTypes(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/SubscriptionsTypes/Get?pageno=${pageNo}&pagesize=${pageSize}
        &Search=${Search}`);
    },

    GetAllSubscriptionsTypes(Id) {
        return axios.get(`api/admin/Dictionaries/SubscriptionsTypes/GetAll?CompaniesId=${Id}`);
    },

    AddSubscriptionsTypes(bodyObject) {
        return axios.post(`api/admin/Dictionaries/SubscriptionsTypes/Add`, bodyObject);
    },

    EditSubscriptionsTypes(bodyObject) {
        return axios.post(`api/admin/Dictionaries/SubscriptionsTypes/Edit`, bodyObject);
    },

    DeleteSubscriptionsTypes(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/SubscriptionsTypes/Delete`);
    },

    ChangeStatusSubscriptionsTypes(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/SubscriptionsTypes/ChangeStatus`);
    },













    GetDashboardInfo() {
        return axios.get(`api/admin/Dictionaries/Dashboard/Get`);
    },



    // ********************************| End Dictionaries |********************************



    // ********************************| Start Financial |********************************


    // Subscriptions
    GetSubscriptions(pageNo, pageSize, Search, UserId, SubscriptionsTypesId) {
        return axios.get(`api/admin/Financial/Subscriptions/Get?pageno=${pageNo}&pagesize=${pageSize}
        &Search=${Search}&UserId=${UserId}&SubscriptionsTypesId=${SubscriptionsTypesId}`);
    },

    AddSubscriptions(bodyObject) {
        return axios.post(`api/admin/Financial/Subscriptions/Add`, bodyObject);
    },

    DeleteSubscriptions(Id) {
        return axios.post(`api/admin/Financial/${Id}/Subscriptions/Delete`);
    },



    SubscriptionsPurchases(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Financial/Subscriptions/Purchases/Get?pageno=${pageNo}&pagesize=${pageSize}
        &Search=${Search}`);
    },




    // Installments
    GetInstallments(Id) {
        return axios.get(`api/admin/Financial/Installments/Get?Id=${Id}`);
    },

    AddInstallments(bodyObject) {
        return axios.post(`api/admin/Financial/Installments/Add`, bodyObject);
    },

    DeleteInstallments(Id) {
        return axios.post(`api/admin/Financial/${Id}/Installments/Delete`);
    },


    // ********************************| End Dictionaries |********************************




































    // ********************************| Users |********************************
    GetUsers(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Users/Get?pageNo=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetUsersTransactions(pageNoT, pageSizeT, Id) {
        return axios.get(`api/admin/Users/GetTransactions?pageNo=${pageNoT}&pagesize=${pageSizeT}&Id=${Id}`);
    },

    GetAllUsers() {
        return axios.get(`api/admin/Users/GetAll`);
    },

    AddUsers(bodyObject) {
        return axios.post('api/admin/Users/Add', bodyObject);
    },

    EditUsers(bodyObject) {
        return axios.post('api/admin/Users/Edit', bodyObject);
    },

    ResetPasswordUsers(Id) {
        return axios.post(`api/admin/Users/${Id}/ResetPassword`);
    },

    ChangeStatusUsers(Id) {
        return axios.post(`api/admin/Users/${Id}/ChangeStatus`);
    },

    DeleteUsers(Id) {
        return axios.post(`api/admin/Users/${Id}/Delete`);
    },


    //USerProfile 
    ChangeProfilePicture(bodyObject) {
        return axios.post('api/admin/Users/Profile/ChangePicture', bodyObject);
    },

    ChangeProfileInfo(bodyObject) {
        return axios.post('api/admin/Users/Profile/ChangeInfo', bodyObject);
    },

    ChangeProfilePassword(bodyObject) {
        return axios.post('api/admin/Users/Profile/ChangePassword', bodyObject);
    },




    // ********************************| End Of Users |********************************




    
    
}